<cbc-container [isLoading]="loading" [showContainer]="!loading" title="Consulta de Acessos e Planos"
    description="Verifique e consulte os dados de acesso e planos">
</cbc-container>

@if(!loading) {
<div class="container">
    <div class="search-section">
        <div class="card">
            <div class="card-body">
                <div class="search-form">
                    <mat-form-field appearance="outline" class="search-input">
                        <mat-label>CPF / CNPJ / Email</mat-label>
                        <mat-icon matPrefix>search</mat-icon>
                        <input matInput [(ngModel)]="query" placeholder="Ex: 61508156000172 ou user@exemplo.com"
                            (keyup.enter)="search()">
                        @if (query) {
                        <button mat-icon-button matSuffix (click)="clear()" matTooltip="Limpar">
                            <mat-icon>close</mat-icon>
                        </button>
                        }
                    </mat-form-field>

                    <div class="search-actions">
                        <button mat-raised-button color="primary" (click)="search()" class="btn btn-primary"
                            [disabled]="loading || !query.trim()">
                            <mat-icon>search</mat-icon>
                            Buscar
                        </button>
                        <button mat-stroked-button (click)="clear()" class="btn btn-ghost" [disabled]="loading">
                            <mat-icon>clear_all</mat-icon>
                            Limpar
                        </button>
                    </div>
                </div>

                @if (loading) {
                <div class="loading-section">
                    <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
                    <p class="loading-text">Buscando informações...</p>
                </div>
                }
            </div>
        </div>
    </div>

    @if (error) {
    <div class="alert alert-error">
        <mat-icon>error_outline</mat-icon>
        <div>
            <strong>Erro:</strong> {{ error }}
        </div>
    </div>
    }

    @if (!loading && results.length === 0 && searched) {
    <div class="alert alert-info">
        <mat-icon>info_outline</mat-icon>
        <div>
            <strong>Nenhum plano encontrado</strong>
            <p>Não foram encontrados planos ativos para o critério de busca informado.</p>
        </div>
    </div>
    }

    @if (results.length > 0) {
    <mat-accordion class="plans-accordion">
        @for (plan of results; track plan.planId) {
        <mat-expansion-panel class="card">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ plan.planName || ('Plano #' + plan.planId) }}
                </mat-panel-title>
                <mat-panel-description>
                    <span class="badge" [ngClass]="{
                        'badge-success': plan.isActive,
                        'badge-warning': plan.requiresAction,
                        'badge-error': !plan.isActive && !plan.requiresAction
                    }">
                        {{ plan.status }}
                    </span>
                    <span style="margin-left: var(--spacing-sm);">{{ plan.cpfCnpj }}</span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="card-body">
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="detail-label">Permite Acesso</span>
                        <span class="detail-value" [class.value-yes]="plan.allowsAccess"
                            [class.value-no]="!plan.allowsAccess">
                            {{ plan.allowsAccess ? 'Sim' : 'Não' }}
                        </span>
                    </div>

                    <div class="detail-item">
                        <span class="detail-label">Requer Ação</span>
                        <span class="detail-value" [class.value-yes]="!plan.requiresAction"
                            [class.value-no]="plan.requiresAction">
                            {{ plan.requiresAction ? 'Sim' : 'Não' }}
                        </span>
                    </div>

                    <div class="detail-item">
                        <span class="detail-label">Status do Plano</span>
                        <span class="detail-value" [class.value-yes]="plan.isActive"
                            [class.value-no]="!plan.isActive">
                            {{ plan.isActive ? 'Ativo' : 'Inativo' }}
                        </span>
                    </div>

                    <div class="detail-item">
                        <span class="detail-label">Dias Restantes</span>
                        <span class="detail-value"
                            [class.value-alert]="plan.daysRemaining !== null && plan.daysRemaining !== undefined && plan.daysRemaining < 30">
                            {{ plan.daysRemaining ?? '—' }}
                        </span>
                    </div>

                    <div class="detail-item">
                        <span class="detail-label">ID do Plano</span>
                        <span class="detail-value">{{ plan.planId }}</span>
                    </div>

                    <div class="detail-item">
                        <span class="detail-label">CPF/CNPJ</span>
                        <span class="detail-value">{{ plan.cpfCnpj }}</span>
                    </div>
                </div>

                @if (plan.message) {
                <div class="message-section">
                    <strong>Mensagem:</strong>
                    <p>{{ plan.message }}</p>
                </div>
                }
            </div>
        </mat-expansion-panel>
        }
    </mat-accordion>
    }
</div>
}